import { css, cx } from '@eti/styles';
import { SlidersHorizontal } from '@phosphor-icons/react';
import { useTranslation, useProperty } from '@eti/providers';
import { Button } from '@etg/wings';
import { useResultPageContext } from '../../v3/contexts/ResultPageContext';

const controlButtonStyles = css`
  width: 100%;
`;

const desktopFiltersButton = css`
  justify-content: center;
`;

const ResultFiltersToggleButton = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isFiltersPanelOpen, toggleFiltersPanel } = useResultPageContext();
  return (
    <Button
      className={cx(
        controlButtonStyles,
        p('Result.Page.V3.DesktopDrawerSearchResultFilters.Enabled') && desktopFiltersButton,
      )}
      data-testid="resultPage-toggleFiltersButton-button"
      iconPrefix={
        <SlidersHorizontal aria-hidden id={isFiltersPanelOpen ? 'close-icon' : 'sliders-icon'} />
      }
      onClick={toggleFiltersPanel}
      size="small"
      type="button"
    >
      {t('Result.Filters.Toggle.Button.Label')}
    </Button>
  );
};

export default ResultFiltersToggleButton;
